// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".smileys-container[data-v-37cbd22c]{position:absolute;top:0;right:0;height:100%;width:25%;z-index:1;pointer-events:none}@keyframes slideBottomToTop-37cbd22c{0%{opacity:0}10%{opacity:1}to{transform:translateY(-100vh);opacity:1}}.slide-enter-active[data-v-37cbd22c]{animation-duration:10s;animation-name:slideBottomToTop-37cbd22c;animation-fill-mode:backwards;animation-timing-function:ease-in}", ""]);
// Exports
module.exports = exports;
